module.exports = __webpack_public_path__ + "images/picto-sect-gigs.png?1d7ab";